import { Navigate, useLocation } from 'react-router-dom';

// Preserve existing links and onboarding handoffs after Explore becomes a Home section.
export const Explore = () => {
    const location = useLocation();
    return (
        <Navigate
            to={{ pathname: '/', search: location.search, hash: '#explore' }}
            state={location.state}
            replace
        />
    );
};

export default Explore;
